module.exports = __webpack_public_path__ + "static/img/ZA.a685ed92.svg";